import { render, staticRenderFns } from "./AgentConsole.vue?vue&type=template&id=f13ea4fa&scoped=true"
import script from "./AgentConsole.vue?vue&type=script&lang=js"
export * from "./AgentConsole.vue?vue&type=script&lang=js"
import style0 from "./AgentConsole.vue?vue&type=style&index=0&id=f13ea4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13ea4fa",
  null
  
)

export default component.exports